import { LegalStructure, MemberForm } from '@/types/businesses';
import showToast from './toast';

export function legalStructureStringGenerator(status: LegalStructure) {
  switch (status) {
    case LegalStructure.CORP:
      return 'Corp';
    case LegalStructure.ESTATE:
      return 'Estate';
    case LegalStructure.LLC:
      return 'LLC';
    case LegalStructure.LLP:
      return 'LLP';
    case LegalStructure.NONPROFIT:
      return 'Non-profit';
    case LegalStructure.SOLEPROPRIETORSHIP:
      return 'Sole Proprietorship';
    case LegalStructure.TRUST:
      return 'Trust';
    default:
      return '';
  }
}

export function validateBusinessMemberForm(data: MemberForm) {
  const ownershipPercentage = data.members.reduce((accumulator, member) => {
    return accumulator + Number(member.ownershipPercentage);
  }, 0);
  if (ownershipPercentage > 100) {
    showToast({
      type: 'error',
      data: {
        content: 'Ownership percent must equal to or less than 100%',
      },
    });
    return false;
  }

  const hasControlPerson = data.members.filter(
    member => member.isControlPerson,
  );
  if (hasControlPerson.length === 0) {
    showToast({
      type: 'error',
      data: {
        content:
          'There must be at least one control person assigned to the business',
      },
    });
    return false;
  }

  return true;
}
